
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import FormField from '@/components/forms/FormField.vue';

import { Actions, Getters } from '@/store/enums/ReminderEnums';
import { ReminderList } from '@/models/ReminderListModel';

/**
 * TODO:
 *
 * Recreate this component when the backend start creating auto-generated
 * passwords
 */

export default defineComponent({
  name: 'reminder-list-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      default: 'col-lg-4',
      type: String,
    },
    name: {
      default: 'reminder',
      type: String,
    },
    label: {
      default: 'Reminders ',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    options: {
      default: null,
      type: Array,
    },
  },
  mounted() {
    this.loadList();
  },
  data: () => ({
    reminderListOptions: [] as unknown as Array<ReminderList>,
  }),
  computed: {
    ...mapGetters({
      reminderLists: Getters.GET_REMINDER_LIST,
    }),
  },
  methods: {
    ...mapActions({
      fetchReminderList: Actions.FETCH_REMINDER_LIST,
    }),
    async loadList() {
      await this.fetchReminderList();
    },
    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },
    async handleSortMailListOptions() {
      let reminderOptions = [] as any;

      if (typeof this.reminderLists !== 'undefined') {
        this.reminderLists.map((reminderList) => {
          reminderOptions.push({
            value: reminderList.system_name,
            label: reminderList.name,
          });
        });

        await reminderOptions.sort((a, b) => {
          let fa = a.label.toLowerCase(),
            fb = b.label.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      }

      this.reminderListOptions = reminderOptions;
    },
  },
});
